module.exports = __webpack_public_path__ + "img/Karafarin.13525cc8.svg";